import AGREGAR_ESTIMACION from '@/graphql/mutations/administracion/ejecuccion/estimaciones/agregarContratoEstimacion.gql';
import ACTUALIZAR_ESTIMACION from '@/graphql/mutations/administracion/ejecuccion/estimaciones/actualizarContratoEstimacion.gql';
import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';
import REMOVER_CONTRATO_ESTIMACION from '@/graphql/mutations/administracion/ejecuccion/estimaciones/removerContratoEstimacion.gql';
import LISTADO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptos.gql';

const PERMITIR_ESTIMACIONES_EN_CERO = true;

export default {
  apollo: {
    contratoCatalogoConceptos: {
      query: LISTADO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
      // Meter los datos a la varible con los datos compuestos
      result({ data }) {
        this.fetchCatalogoConceptos(data.contratoCatalogoConceptos);
      },
    },
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    fetchCatalogoConceptos(catalogo) {
      this.catalogoDeConceptos = catalogo.filter(
        (concepto) => concepto.clave !== null && concepto.clave !== 'null',
      )
        .slice()
        .map((concepto) => {
          const estimadoAnterior = this.$numberRoundDigits(concepto.estimado
            .reduce((anterior, estimacion) => anterior + estimacion.cantidad, 0), 5);
          const cantidadDisponible = this
            .$numberRoundDigits((concepto.cantidad - estimadoAnterior), 5);

          return {
            ...concepto,
            nuevaCantidad: 0,
            estimadoAnterior,
            cantidadDisponible,
          };
        })
        .sort((a, b) => a.orden - b.orden);
    },
    fetchCatalogoConceptosEdicion(catalogo) {
      this.catalogoDeConceptos = catalogo.filter(
        (concepto) => concepto.clave !== null && concepto.clave !== 'null',
      )
        .slice()
        .map((concepto) => {
          const { conceptos } = this.estimacionEditar;
          const conceptoEstimado = conceptos.find(({ idConcepto }) => idConcepto === concepto.id);

          if (!conceptoEstimado) {
            const estimadoAnterior = this.$numberRoundDigits(concepto.estimado
              .reduce((anterior, estimacion) => anterior + estimacion.cantidad, 0), 5);
            const cantidadDisponible = this
              .$numberRoundDigits((concepto.cantidad - estimadoAnterior), 5);

            return {
              ...concepto,
              nuevaCantidad: 0,
              estimadoAnterior,
              cantidadDisponible,
            };
          }

          const estimadoAnterior = this.$numberRoundDigits(concepto.estimado
            .reduce((anterior, estimacion) => anterior + estimacion.cantidad, 0), 5);
          const cantidadDisponible = this
            .$numberRoundDigits((concepto.cantidad - estimadoAnterior), 5);

          return {
            nuevaCantidad: 850000,
            estimadoAnterior,
            cantidadDisponible,
          };
        })
        .sort((a, b) => a.orden - b.orden);
    },
    cerrar() {
      this.estimacion.conceptos = [];
      this.estimacion.deducciones = [];
      this.$emit('cerrar');
    },
    async guardar() {
      this.enviadoFormulario = true;
      this.mixEsCargando();

      // Validar que existan conceptos a estimar
      if (!PERMITIR_ESTIMACIONES_EN_CERO && this.importeTotalEstimado <= 0) {
        this.mixMensajeError('Debe de estimar por lo menos un concepto.');
        this.mixEsCargando();
        return;
      }

      // Comprobar si el importe estimado actual (estimaciones anteriores + actual)
      // no sea mayor al importe del contrato mas sus moficaciones
      if (this.$numberRound(this.importeEstimadoActual) > this.importeDelContrato) {
        this.mixMensajeError('El importe Estimado es mayor al importe del Contrato');
        this.mixEsCargando();
        return;
      }

      // Sumar los importes de los contratos
      this.sumarImportesContrato();

      // Formato del programa
      this.estimacion.programa = this.mixGetPrograma
        .map(({
          fechaInicio, fechaTermino, plazo, monto, avance,
        }) => ({
          fechaInicio,
          fechaTermino,
          plazo,
          monto,
          avance,
        }));

      await this.$apollo
        .mutate({
          mutation: AGREGAR_ESTIMACION,
          variables: {
            estimacion: this.estimacion,
          },
          update: (store, { data: { agregarContratoEstimacion } }) => {
            const query = {
              query: CONTRATO_ESTIMACIONES,
              variables: {
                idContrato: this.$route.params.idContrato,
              },
            };
            const { contratoEstimaciones } = store.readQuery(query);
            const contratoEstimacionesCopia = contratoEstimaciones.slice();
            contratoEstimacionesCopia.push(agregarContratoEstimacion);
            store.writeQuery({
              ...query,
              data: {
                contratoEstimaciones: contratoEstimacionesCopia,
              },
            });
          },
        })
        .then(async () => {
          this.mixMensajeSuccess();

          this.cerrar();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      await this.$apollo.queries.contratoCatalogoConceptos.refetch({
        idContrato: this.$route.params.idContrato,
      });

      this.enviadoFormulario = false;
      this.mixEsCargando();
    },

    async mixActualizar() {
      const { id } = this.estimacionEditar;
      this.enviadoFormulario = true;
      this.mixEsCargando();

      // Validar que existan conceptos a estimar
      if (!PERMITIR_ESTIMACIONES_EN_CERO && this.importeTotalEstimado <= 0) {
        this.mixMensajeError('Debe de estimar por lo menos un concepto.');
        this.mixEsCargando();
        return;
      }

      // Comprobar si el importe estimado actual (estimaciones anteriores + actual)
      // no sea mayor al importe del contrato mas sus moficaciones
      if (this.$numberRound(this.importeEstimadoActual) > this.importeDelContrato) {
        this.mixMensajeError('El importe Estimado es mayor al importe del Contrato');
        this.mixEsCargando();
        return;
      }

      // Sumar los importes de los contratos
      this.sumarImportesContrato();

      // Formato del programa
      this.estimacion.programa = this.mixGetPrograma
        .map(({
          fechaInicio, fechaTermino, plazo, monto, avance,
        }) => ({
          idEstimacion: id,
          fechaInicio,
          fechaTermino,
          plazo,
          monto,
          avance,
        }));

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_ESTIMACION,
          variables: {
            id,
            estimacion: this.estimacion,
          },
          update: (store, { data: { actualizarContratoEstimacion } }) => {
            const query = {
              query: CONTRATO_ESTIMACIONES,
              variables: {
                idContrato: this.$route.params.idContrato,
              },
            };
            const { contratoEstimaciones } = store.readQuery(query);
            const index = contratoEstimaciones.findIndex((estimacion) => estimacion.id === id);
            if (index !== -1) {
              contratoEstimaciones.splice(index, 1, actualizarContratoEstimacion);
            }
            store.writeQuery({
              ...query,
              data: {
                contratoEstimaciones,
              },
            });
          },
        })
        .then(async () => {
          this.mixMensajeSuccess();

          this.cerrar();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      await this.$apollo.queries.contratoCatalogoConceptos.refetch({
        idContrato: this.$route.params.idContrato,
      });

      this.enviadoFormulario = false;
      this.mixEsCargando();
    },

    // Sumar los importes del contrato
    sumarImportesContrato() {
      this.estimacion.importeContratoConFinanciamiento = (this.contrato.importe
        + this.importeContratoModificado);
      this.estimacion.importeContratoSinFinanciamiento = this.$numberRoundDigits(
        (this.contrato.importeTotal + this.importeContratoModificado), 2,
      );
    },

    async mixEliminarEstimacion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const { id, idContrato } = this.contratoEstimacionEliminar;

      await this.$apollo
        .mutate({
          mutation: REMOVER_CONTRATO_ESTIMACION,
          variables: {
            id,
          },
          update: (store) => {
            const query = {
              query: CONTRATO_ESTIMACIONES,
              variables: {
                idContrato,
              },
            };

            const data = store.readQuery(query);
            const { contratoEstimaciones } = data;
            const index = contratoEstimaciones
              .findIndex((estimacion) => estimacion.id === id);
            if (index !== -1) {
              contratoEstimaciones.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      await this.$apollo.queries.contratoCatalogoConceptos.refetch({
        idContrato: this.$route.params.idContrato,
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrarEliminar();
    },
    calculos() {
      // Estimado Neto
      // this.estimacion.importeNeto = this.estimacion.importeEstimado
      //   - this.estimacion.importeRetenido
      //   + this.estimacion.importeDevuelto;
      this.estimacion.importeNeto = this.estimacion.importeEstimado;

      // Calcular deducciones
      this.mixCalcularDeducciones();
      // Calcular porcentaje de avance financiero
      this.calcularPorcentajeAvanceFinanciero();
      // Calcular porcentaje de avance fisico
      this.calcularPorcentajeAvanceFisico();

      // AMORTIZACION DE ANTICIPO
      // set Datos del anticipo
      this.estimacion.importeAnticipo = this.getImporteTotalAnticipoContratos;
      this.estimacion.importeAnticipoFinanciamiento = this
        .getImporteTotalAnticipoContratadoFinanciado;

      // Cechecar si es estimacion finiquito o se amortizara todo el anticipo
      if (this.amortizarAnticipo || this.estimacion.esEstimacionFiniquito) {
        this.estimacion.importeAmortizacionAnticipo = this.getImporteTotalAnticipoContratos
          - this.importeAnticipoAmortizadoTotal;
      } else {
        // Calcular la amortizacion de anticipo
        this.estimacion.importeAmortizacionAnticipo = this.$numberRound(
          this.estimacion.importeNeto * (this.estimacion.porcentajeAnticipo / 100),
        );

        if (this.estimacion.importeAmortizacionAnticipo > this.estimacion.importeEstimado) {
          this.estimacion.importeAmortizacionAnticipo = this.estimacion.importeEstimado;
        }

        // Si la suma de amortazacion actual mas las anteriores es mayor a el anticipo otorgado
        if (
          (this.estimacion.importeAmortizacionAnticipo + this.importeAnticipoAmortizadoTotal)
          > this.getImporteTotalAnticipoContratos) {
          // si es mayor
          this.estimacion.importeAmortizacionAnticipo = this.getImporteTotalAnticipoContratos
          - this.importeAnticipoAmortizadoTotal;
        }
      }

      // Amortizacion del anticipo financiado
      this.mixCalcularAnticipoFinanciado();

      // Si es la estimacion finiquito checar los centavos de la amortizacion del anticipo
      if (
        this.estimacion.esEstimacionFiniquito
        && this.getImporteAjusteAlAmortizado !== 0
        && this.getImporteAjusteAlAmortizado < 0.1
        && this.getImporteAjusteAlAmortizado > -0.1
      ) {
        this.estimacion.importeAmortizacionAnticipo
          += this.getImporteAjusteAlAmortizado;
      }

      // Subtotal
      this.estimacion.subtotal = this.$numberRound(this.estimacion.importeNeto
        - this.estimacion.importeAmortizacionAnticipo);

      // Subtotal 2
      this.estimacion.subtotalDos = this.$numberRound((this.estimacion.importeCostoFinanciero
      + this.estimacion.subtotal));

      // Importe IVA
      this.estimacion.importeIva = this.$numberRound(
        this.estimacion.subtotalDos * (this.estimacion.porcentajeIva / 100),
      );

      // Si es la estimacion finiquito checar los centavos del importe de IVA
      // if (
      //   this.estimacion.esEstimacionFiniquito
      //   && this.getImporteAjusteIva !== 0
      //   && this.getImporteAjusteIva < 0.1
      //   && this.getImporteAjusteIva > -0.1
      // ) {
      //   this.estimacion.importeIva += this.getImporteAjusteIva;
      // }

      // Total de Factura
      this.estimacion.totalFactura = this.estimacion.subtotalDos + this.estimacion.importeIva;

      // Total deducciones
      this.estimacion.importeDeducciones = this.mixGetTotalContratoDeducciones();

      // Importe Liquido
      this.estimacion.importeLiquido = this.estimacion.totalFactura
        - (this.estimacion.importeDeducciones + this.estimacion.importeSancion)
        - this.estimacion.importeRetenido
        + this.estimacion.importeDevuelto
        + this.estimacion.importeBonificacion;
    },
    marcarEstimacionFinPrograma() {
      const { fechaTermino } = this.programa.programaFinal;
      this.estimacion.esEstimacionFinPrograma = fechaTermino === this.estimacion.fechaAl;
    },
    calcularPorcentajeAvanceFinanciero() {
      const { importeEstimado } = this.estimacion;
      if (importeEstimado > 0) {
        this.estimacion.porcentajeAvanceFinanciero = this.$numberRoundDigits(
          (importeEstimado / this.importeDelContrato),
          4,
        );
      }
    },
  },
};
